(function($) {
    if ($(".collection-sidebar")) {
        //work only in collection page
        History.Adapter.bind(window, 'statechange', function() {
            var State = History.getState();
            if (!fashiondable.isSidebarAjaxClick) {
                fashiondable.sidebarParams();
                var newurl = fashiondable.sidebarCreateUrl();
                fashiondable.sidebarGetContent(newurl);
                fashiondable.reActivateSidebar();
            }
            fashiondable.isSidebarAjaxClick = false;
        });
    }

    if (window.use_color_swatch) {
        $('.swatch :radio').change(function() {
            var optionIndex = $(this).closest('.swatch').attr('data-option-index');
            var optionValue = $(this).val();
            $(this)
                .closest('form')
                .find('.single-option-selector')
                .eq(optionIndex)
                .val(optionValue)
                .trigger('change');
        });

        // (c) Copyright 2014 Caroline Schnapp. All Rights Reserved. Contact: mllegeorgesand@gmail.com
        // See http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options

        Shopify.optionsMap = {};

        Shopify.updateOptionsInSelector = function(selectorIndex) {

            switch (selectorIndex) {
                case 0:
                    var key = 'root';
                    var selector = $('.single-option-selector:eq(0)');
                    break;
                case 1:
                    var key = $('.single-option-selector:eq(0)').val();
                    var selector = $('.single-option-selector:eq(1)');
                    break;
                case 2:
                    var key = $('.single-option-selector:eq(0)').val();
                    key += ' / ' + $('.single-option-selector:eq(1)').val();
                    var selector = $('.single-option-selector:eq(2)');
            }

            var initialValue = selector.val();
            selector.empty();
            var availableOptions = Shopify.optionsMap[key];

        };

        Shopify.linkOptionSelectors = function(product) {
            // Building our mapping object.
            for (var i = 0; i < product.variants.length; i++) {
                var variant = product.variants[i];
                if (variant.available) {
                    // Gathering values for the 1st drop-down.
                    Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
                    Shopify.optionsMap['root'].push(variant.option1);
                    Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
                    // Gathering values for the 2nd drop-down.
                    if (product.options.length > 1) {
                        var key = variant.option1;
                        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                        Shopify.optionsMap[key].push(variant.option2);
                        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
                    }
                    // Gathering values for the 3rd drop-down.
                    if (product.options.length === 3) {
                        var key = variant.option1 + ' / ' + variant.option2;
                        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                        Shopify.optionsMap[key].push(variant.option3);
                        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
                    }
                }
            }
            // Update options right away.
            Shopify.updateOptionsInSelector(0);
            if (product.options.length > 1) Shopify.updateOptionsInSelector(1);
            if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
            // When there is an update in the first dropdown.
            $(".single-option-selector:eq(0)").change(function() {
                Shopify.updateOptionsInSelector(1);
                if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
                return true;
            });
            // When there is an update in the second dropdown.
            $(".single-option-selector:eq(1)").change(function() {
                if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
                return true;
            });

        };
    }

    $(document).ready(function() {
        fashiondable.init();
    });

    $(window).resize(function() {
//         fashiondable.initMobileMenu();
        //fashiondable.initMobileSidebar();
        fashiondable.initResizeImage();
    });

    $(window).scroll(function() {
        if ($(this).scrollTop() > 200) {
            $('#back-top').fadeIn();
        } else {
            $('#back-top').fadeOut();
        }
    });
  function checkShopTheLook(){
    var count = 0;
    $('.mini-products .wrap-product-list-item').each(function(i){
      var id = $(this).attr('data-id');
      if(document.cookie.indexOf(id) < 0) {
        if(count == 0){
          $('#'+id).addClass('active');
        }
        count = count + 1;
      } else{
        $('#'+id).addClass('removed');
      }
    });
  };

    function alignHeight(){
      var minHeightName = 0;
       jQuery('#bc-sf-filter-products .bc-sf-filter-product-top .bc-sf-filter-product-item-image').each(function(){
        if (minHeightName < jQuery(this).outerHeight()) {
          minHeightName = jQuery(this).outerHeight();
        }
       });
       if (minHeightName > 0) {

        jQuery('#bc-sf-filter-products .bc-sf-filter-product-top .bc-sf-filter-product-item-image').css('height', minHeightName);
       }
    }

    setInterval(function(){
       //alignHeight();
    }, 800);
    //alignHeight();
    $(window).resize(function(){
        //alignHeight();
    });

    if (!$(".header-mobile").is(":visible")) {
        $(document).on('click touchstart', function(e) {
            var quickview = $(".quick-view");
            var dropdowncart = $("#dropdown-cart");
            var cartButton = $("#cartToggle");
            var newsletter = $("#email-modal .modal-window");
            var searchBar = $(".nav-search");
            //close quickview and dropdowncart when clicking outside
            if (!quickview.is(e.target) && quickview.has(e.target).length === 0 && !dropdowncart.is(e.target) && dropdowncart.has(e.target).length === 0 && !cartButton.is(e.target) && cartButton.has(e.target).length === 0 && !newsletter.is(e.target) && newsletter.has(e.target).length === 0 && !searchBar.is(e.target) && searchBar.has(e.target).length === 0) {
                fashiondable.closeQuickViewPopup();
                fashiondable.closeDropdownCart();
                fashiondable.closeEmailModalWindow();
                fashiondable.closeDropdownSearch();
            }
        });
    }

    $(document).on('prepare-quick-view', function (value) {
      fashiondable.prepareQuickView($(value.originalEvent.detail.selector));
    })

    $(document).on('prepare-quick-add', function () {
      setTimeout(() => fashiondable.initAddToCart(), 500);
    })

    $(document).keyup(function(e) {
        if (e.keyCode == 27) {
            fashiondable.closeQuickViewPopup();
            fashiondable.closeDropdownCart();
            fashiondable.closeDropdownSearch();
            clearTimeout(fashiondable.fashiondableTimeout);
            if ($('.modal').is(':visible')) {
                $('.modal').fadeOut(500);
            }
        }
    });

  var fashiondable = {
    fashiondableTimeout: null,
    isSidebarAjaxClick: false,
    init: function() {
      this.initColorSwatchGrid();
      this.initResizeImage();
      this.initMobileMenu();
      this.initSidebar();
      this.initMobileSidebar();
      this.initScrollTop();
      this.initDropdown();
      this.initQuickView();
      this.initCloudzoom();
      this.initProductMoreview();
      this.initAddToCart();
      this.initModal();
      this.initProductAddToCart();
      this.initDropDownCart();
      this.initDropdownSearch();
      this.initToggleCollectionPanel();
      this.initWishlist();
      this.initProductWishlist();
      this.initRemoveWishlist();
      this.initInfiniteScrolling();
    },
    sidebarMapTagEvents: function() {
      $('.sidebar-tag a:not(".clear"), .sidebar-tag label').click(function(e) {
        var currentTags = [];
        if (Shopify.queryParams.constraint) {
          currentTags = Shopify.queryParams.constraint.split('+');
        }

                //one selection or multi selection
                if (!window.enable_sidebar_multiple_choice && !$(this).prev().is(":checked")) {
                    //remove other selection first
                    var otherTag = $(this).parents('.sidebar-tag').find("input:checked");
                    if (otherTag.length > 0) {
                        var tagName = otherTag.val();
                        if (tagName) {
                            var tagPos = currentTags.indexOf(tagName);
                            if (tagPos >= 0) {
                                //remove tag
                                currentTags.splice(tagPos, 1);
                            }
                        }
                    }
                }

                var tagName = $(this).prev().val();
                if (tagName) {
                    var tagPos = currentTags.indexOf(tagName);
                    if (tagPos >= 0) {
                        //tag already existed, remove tag
                        currentTags.splice(tagPos, 1);
                    } else {
                        //tag not existed
                        currentTags.push(tagName);
                    }
                }
                if (currentTags.length) {
                    Shopify.queryParams.constraint = currentTags.join('+');
                } else {
                    delete Shopify.queryParams.constraint;
                }
                fashiondable.sidebarAjaxClick();
                e.preventDefault();
            });
        },
        sidebarMapCategories: function() {
            $(".sidebar-links a").click(function(e) {
                if (!$(this).hasClass('active')) {
                    delete Shopify.queryParams.q;
                    fashiondable.sidebarAjaxClick($(this).attr('href'));

                    //activate selected category
                    $(".sidebar-links a.active").removeClass("active");
                    $(this).addClass("active");
                }
                e.preventDefault();
            });
        },
        sidebarMapView: function() {
            $(".view-mode a").click(function(e) {
                if (!$(this).hasClass("active")) {
                    var paging = $(".filter-show > button span").text();
                    if ($(this).hasClass("list")) {
                        Shopify.queryParams.view = "list" + paging;
                    } else {
                        Shopify.queryParams.view = paging;
                    }

                    fashiondable.sidebarAjaxClick();
                    $(".view-mode a.active").removeClass("active");
                    $(this).addClass("active");
                }
                e.preventDefault();
            });
        },
        sidebarMapShow: function() {
            $(".filter-show a").click(function(e) {
                if (!$(this).parent().hasClass("active")) {
                    var thisPaging = $(this).attr('href');

                    var view = $(".view-mode a.active").attr("href");
                    if (view == "list") {
                        Shopify.queryParams.view = "list" + thisPaging;
                    } else {
                        Shopify.queryParams.view = thisPaging;
                    }

                    fashiondable.sidebarAjaxClick();
                    $(".filter-show > button span").text(thisPaging);
                    $(".filter-show li.active").removeClass("active");
                    $(this).parent().addClass("active");
                }
                e.preventDefault();
            });
        },
        sidebarInitToggle: function() {
            if ($(".sidebar-tag").length > 0) {
                $(".sidebar-tag .widget-title span").click(function() {
                    var $title = $(this).parents('.widget-title');
                    if ($title.hasClass('click')) {
                        $title.removeClass('click');
                    } else {
                        $title.addClass('click');
                    }

                    $(this).parents(".sidebar-tag").find(".widget-content").slideToggle();
                });
            }
        },
        sidebarMapSorting: function(e) {
            $(".filter-sortby a").click(function(e) {
                if (!$(this).parent().hasClass("active")) {
                    Shopify.queryParams.sort_by = $(this).attr("href");
                    fashiondable.sidebarAjaxClick();
                    var sortbyText = $(this).text();
                    $(".filter-sortby > button span").text(sortbyText);
                    $(".filter-sortby li.active").removeClass("active");
                    $(this).parent().addClass("active");
                }
                e.preventDefault();
            });
        },
        sidebarMapPaging: function() {
            $(".pagination-page a").click(function(e) {
                var page = $(this).attr("href").match(/page=\d+/g);
                if (page) {
                    Shopify.queryParams.page = parseInt(page[0].match(/\d+/g));
                    if (Shopify.queryParams.page) {
                        var newurl = fashiondable.sidebarCreateUrl();
                        fashiondable.isSidebarAjaxClick = true;
                        History.pushState({
                            param: Shopify.queryParams
                        }, newurl, newurl);
                        fashiondable.sidebarGetContent(newurl);
                        //go to top
                        $('body,html').animate({
                            scrollTop: 500
                        }, 600);
                    }
                }
                e.preventDefault();
            });
        },
        sidebarMapClearAll: function() {
            //clear all selection
            $('.refined-widgets a.clear-all').click(function(e) {
                delete Shopify.queryParams.constraint;
                delete Shopify.queryParams.q;
                fashiondable.sidebarAjaxClick();
                e.preventDefault();
            });
        },
      ClearSelected: function(){
            $('.selected-tag a').click(function(e) {
                var currentTags = [];
                if (Shopify.queryParams.constraint) {
                    currentTags = Shopify.queryParams.constraint.split('+');
                }

                //one selection or multi selection
                if (!window.enable_sidebar_multiple_choice && !$(this).prev().is(":checked")) {
                    //remove other selection first
                    var otherTag = $(this).parents('.selected-tag').find("input:checked");
                    if (otherTag.length > 0) {
                        var tagName = otherTag.val();
                        if (tagName) {
                            var tagPos = currentTags.indexOf(tagName);
                            if (tagPos >= 0) {
                                //remove tag
                                currentTags.splice(tagPos, 1);
                            }
                        }
                    }
                }

                var tagName = $(this).prev().val();
                if (tagName) {
                    var tagPos = currentTags.indexOf(tagName);
                    if (tagPos >= 0) {
                        //tag already existed, remove tag
                        currentTags.splice(tagPos, 1);
                    } else {
                        //tag not existed
                        currentTags.push(tagName);
                    }
                }
                if (currentTags.length) {
                    Shopify.queryParams.constraint = currentTags.join('+');
                } else {
                    delete Shopify.queryParams.constraint;
                }
                fashiondable.sidebarAjaxClick();
                e.preventDefault();
            });
      },
        sidebarMapClear: function() {
            $(".sidebar-tag").each(function() {
                var sidebarTag = $(this);
                if (sidebarTag.find("input:checked").length > 0) {
                    //has active tag
                    sidebarTag.find(".clear").show().click(function(e) {
                        var currentTags = [];
                        if (Shopify.queryParams.constraint) {
                            currentTags = Shopify.queryParams.constraint.split('+');
                        }
                        sidebarTag.find("input:checked").each(function() {
                            var selectedTag = $(this);
                            var tagName = selectedTag.val();
                            if (tagName) {
                                var tagPos = currentTags.indexOf(tagName);
                                if (tagPos >= 0) {
                                    //remove tag
                                    currentTags.splice(tagPos, 1);
                                }
                            }
                        });
                        if (currentTags.length) {
                            Shopify.queryParams.constraint = currentTags.join('+');
                        } else {
                            delete Shopify.queryParams.constraint;
                        }
                        fashiondable.sidebarAjaxClick();
                        e.preventDefault();
                    });
                }
            });
        },
        sidebarMapEvents: function() {
            fashiondable.sidebarMapTagEvents();
            fashiondable.sidebarMapCategories();
            fashiondable.sidebarMapView();
            fashiondable.sidebarMapShow();
            fashiondable.sidebarMapSorting();
        },
        reActivateSidebar: function() {
            $(".sidebar-custom .active, .sidebar-links .active").removeClass("active");
            $(".sidebar-tag input:checked").attr("checked", false);

            //category
            var cat = location.pathname.match(/\/collections\/(.*)(\?)?/);
            if (cat && cat[1]) {
                $(".sidebar-links a[href='" + cat[0] + "']").addClass("active");
            }

            //view mode and show filter
            if (Shopify.queryParams.view) {
                $(".view-mode .active").removeClass("active");
                var view = Shopify.queryParams.view;
                if (view.indexOf("list") >= 0) {
                    $(".view-mode .list").addClass("active");
                    //paging
                    view = view.replace("list", "");
                } else {
                    $(".view-mode .grid").addClass("active");
                }
                $(".filter-show > button span").text(view);
                $(".filter-show li.active").removeClass("active");
                $(".filter-show a[href='" + view + "']").parent().addClass("active");
            }
            fashiondable.initSortby();
        },
        initSortby: function() {
            //sort by filter
            if (Shopify.queryParams.sort_by) {
                var sortby = Shopify.queryParams.sort_by;
                var sortbyText = $(".filter-sortby a[href='" + sortby + "']").text();
                $(".filter-sortby > button span").text(sortbyText);
                $(".filter-sortby li.active").removeClass("active");
                $(".filter-sortby a[href='" + sortby + "']").parent().addClass("active");
            }
        },
        sidebarMapData: function(data) {
            var currentList = $(".col-main .products-grid");
            if (currentList.length == 0) {
                currentList = $(".col-main .product-list");
            }
            var productList = $(data).find(".col-main .products-grid");
            if (productList.length == 0) {
                productList = $(data).find(".col-main .product-list");
            }
            if (productList.length > 0 && productList.hasClass("products-grid")) {
                if (window.product_image_resize) {
                    productList.find('img').fakecrop({
                        fill: window.images_size.is_crop,
                        widthSelector: ".products-grid .grid-item .product-image",
                        ratioWrapper: window.images_size
                    });
                }
            }
            currentList.replaceWith(productList);
            //convert currency
            if (fashiondable.checkNeedToConvertCurrency()) {
                Currency.convertAll(window.shop_currency, jQuery('.currencies').val(), '.col-main span.money', 'money_format');
            }

            //replace paging
            if ($(".padding").length > 0) {
                $(".padding").replaceWith($(data).find(".padding"));
            } else {
                $(".block-row.col-main").append($(data).find(".padding"));
            }

            //replace title & description
            var currentHeader = $(".page-header");
            var dataHeader = $(data).find(".page-header");
            if (currentHeader.find("h2").text() != dataHeader.find("h2").text()) {
                currentHeader.find("h2").replaceWith(dataHeader.find("h2"));

                var currentDes = $(".collection-des");
                var dataDes = $(data).find(".collection-des");

                if (currentDes.find(".rte").length) {
                    if (dataDes.find(".rte").length) {
                        currentDes.html(dataDes.find(".rte"));
                    } else {
                        currentDes.find(".rte").hide();
                    }
                } else {
                    currentDes.html(dataDes.find(".rte"));
                }

                var currentImg = $(".collection-img");
                var dataImg = $(data).find(".collection-img");
                if (currentImg.find("p").length) {
                    if (dataImg.find("p").length) {
                        currentImg.html(dataImg.find("p"));
                    } else {
                        currentImg.find("p").hide();
                    }
                } else {
                    currentImg.html(dataImg.find("p"));
                }
            }

            //replace refined
            $(".refined-widgets").replaceWith($(data).find(".refined-widgets"));

      //replace tags
      var newSider = $(data).find(".sidebar-block");
      $(".collection-sidebar .sidebar-block .sidebar-custom").each( function(){
        var sc_id = '#'+$(this).attr('id');
      	var widget_title = $(this).find('.widget-title.accordion');
        if(widget_title.hasClass('click')){
          var ns_sc_id = newSider.find(sc_id);
          ns_sc_id.find('.widget-title.accordion').addClass('click');
          ns_sc_id.find('.widget-content').css("display", "block");
        }
      });
      $(".sidebar-block").replaceWith(newSider);


      // breadcrumb
      $(".breadcrumb .bd-title").replaceWith($(data).find(".breadcrumb .bd-title"));

            fashiondable.initColorSwatchGrid();

            //product review
            if ($(".spr-badge").length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
            }
        },
        sidebarCreateUrl: function(baseLink) {
            var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
            if (baseLink) {
                //location.href = baseLink + "?" + newQuery;
                if (newQuery != "")
                    return baseLink + "?" + newQuery;
                else
                    return baseLink;
            }
            return location.pathname + "?" + newQuery;
        },
        sidebarAjaxClick: function(baseLink) {
            delete Shopify.queryParams.page;
            var newurl = fashiondable.sidebarCreateUrl(baseLink);
            fashiondable.isSidebarAjaxClick = true;
            History.pushState({
                param: Shopify.queryParams
            }, newurl, newurl);
            fashiondable.sidebarGetContent(newurl);
        },
        sidebarGetContent: function(newurl) {
            $.ajax({
                type: 'get',
                url: newurl,
                beforeSend: function() {
                    fashiondable.showLoading();
                },
                success: function(data) {
                    fashiondable.sidebarMapData(data);
                    fashiondable.sidebarMapPaging();
                    fashiondable.translateBlock(".main-content");
                    fashiondable.sidebarMapTagEvents();
                    fashiondable.sidebarInitToggle();
                    fashiondable.sidebarMapClear();
                    fashiondable.sidebarMapClearAll();
                    fashiondable.ClearSelected();
                    fashiondable.hideLoading();
                    fashiondable.initQuickView();
                    fashiondable.initAddToCart();
                    fashiondable.initWishlist();
                    fashiondable.initInfiniteScrolling();
                    buildColorSwatches()
                    getButtonTrigger()
                },
                error: function(xhr, text) {
                    fashiondable.hideLoading();
                    $('.loading-modal').hide();
                    $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                    fashiondable.showModal('.ajax-error-modal');
                }
            });
        },
        sidebarParams: function() {
            Shopify.queryParams = {};
            //get after ?...=> Object {q: "Acme"}
            if (location.search.length) {
                for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                    aKeyValue = aCouples[i].split('=');
                    if (aKeyValue.length > 1) {
                        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                    }
                }
            }
        },
        initMobileSidebar: function() {
            //if ($(".header-mobile").is(":visible")) {
            $('footer').append("<a class='option-sidebar left' id='displayTextLeft' href='javascript:void(0)' title='Show Sidebar'><span>Show Filter</span></a>");
            $('#displayTextLeft').click(
                function(event) {
                    event.preventDefault();
                    if ($('.sidebar').is(":hidden")) {
                        //jQuery('.col-main').fadeOut(800);
                        $('.sidebar').fadeIn(800);
                        $('body,html').animate({
                            scrollTop: 400
                        }, 600);
                        $('#displayTextLeft').toggleClass('hidden-arrow-left');
                        $('#displayTextLeft').attr('title', 'hide-sidebar');
                        $('#displayTextLeft').html('<span>Hide Filter</span>');
                    } else {
                        $('.sidebar').fadeOut(800);
                        $('#displayTextLeft').removeClass('hidden-arrow-left');
                        $('#displayTextLeft').attr('title', 'show-sidebar');
                        $('#displayTextLeft').html('<span>Show Filter</span>');
                        //jQuery('.col-main').fadeIn(800);
                    }
                });
            //}
        },
        initSidebar: function() {
            //if category page then init sidebar
            if ($(".collection-sidebar").length > 0) {
                fashiondable.sidebarParams();
                fashiondable.initSortby();
                fashiondable.sidebarMapEvents();
                fashiondable.sidebarMapPaging();
                fashiondable.sidebarInitToggle();
                fashiondable.sidebarMapClear();
                fashiondable.sidebarMapClearAll();
                fashiondable.ClearSelected();
            }
        },
       initMobileMenu: function() {
          $('nav#menu').mmenu({
            iconPanels: { add: true, visible: 1 },
            navbar: { add: false }
          });


            var curr = $('.currency_switcher').val();
            jQuery('.currencies-mb').text(curr);


        },
        initWishlist: function() {
            $('.grid-item button.wishlist').click(function(e) {
                e.preventDefault();
                var form = $(this).parent();
                var item = form.parents('.grid-item');
                $.ajax({
                    type: 'POST',
                    url: '/contact',
                    data: form.serialize(),
                    beforeSend: function() {
                        fashiondable.showLoading();
                    },
                    success: function(data) {
                        fashiondable.hideLoading();
                        form.html('<a class="wishlist" href="/pages/wish-list" title="Go to wishlist"><span class="icon"></span><span>Go to wishlist</span></a>');
                        var title = item.find('.product-title').html();
                        var image = item.find('a > img').attr('src');
                        $('.ajax-success-modal').find('.ajax-product-title').html(title);
                        $('.ajax-success-modal').find('.ajax-product-image').attr('src', image);
                        $('.ajax-success-modal').find('.btn-go-to-wishlist').show();
                        $('.ajax-success-modal').find('.btn-go-to-cart').hide();
                        fashiondable.showModal('.ajax-success-modal');
                    },
                    error: function(xhr, text) {
                        fashiondable.hideLoading();
                        $('.loading-modal').hide();
                        $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                        fashiondable.showModal('.ajax-error-modal');
                    }
                });
            });
        },
        initProductWishlist: function() {
            $('.product button.wishlist').click(function(e) {
                e.preventDefault();
                var form = $(this).parent();
                var item = form.parents('.grid-item');
                $.ajax({
                    type: 'POST',
                    url: '/contact',
                    data: form.serialize(),
                    beforeSend: function() {
                        fashiondable.showLoading();
                    },
                    success: function(data) {
                        fashiondable.hideLoading();
                        form.html('<a class="wishlist" href="/pages/wish-list" title="Go to wishlist"><span class="icon"></span><span>Go to wishlist</span></a>');
                        var title = $('.product-title h2').html();
                        var image = $('#product-featured-image').attr('src');
                        $('.ajax-success-modal').find('.ajax-product-title').html(title);
                        $('.ajax-success-modal').find('.ajax-product-image').attr('src', image);
                        $('.ajax-success-modal').find('.btn-go-to-wishlist').show();
                        $('.ajax-success-modal').find('.btn-go-to-cart').hide();
                        fashiondable.showModal('.ajax-success-modal');
                    },
                    error: function(xhr, text) {
                        fashiondable.hideLoading();
                        $('.loading-modal').hide();
                        $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                        fashiondable.showModal('.ajax-error-modal');
                    }
                });
            });
        },
        initRemoveWishlist: function() {
            $('.btn-remove-wishlist').click(function(e) {
                var row = $(this).parents('tr');
                var tagID = row.find('.tag-id').val();
                var form = jQuery('#remove-wishlist-form');
                form.find("input[name='contact[tags]']").val( tagID);
                $.ajax({
                    type: 'POST',
                    url: '/contact',
                    data: form.serialize(),
                    beforeSend: function() {
                        fashiondable.showLoading();
                    },
                    success: function(data) {
                        fashiondable.hideLoading();
                        row.fadeOut(1000);
                    },
                    error: function(xhr, text) {
                        fashiondable.hideLoading();
                        $('.loading-modal').hide();
                        $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                        fashiondable.showModal('.ajax-error-modal');
                    }
                });
            });
        },
        initColorSwatchGrid: function() {
          jQuery('.item-swatch li label').hover(function(){
            var newImage = jQuery(this).parent().find('.hidden a').attr('href');
            jQuery(this).parents('.grid-item').find('.product-grid-image img').attr({ src: newImage });
            return false;
          });
        },
        initResizeImage: function() {
            if (window.product_image_resize) {
                $('.products-grid .product-image img').fakecrop({
                    fill: window.images_size.is_crop,
                    widthSelector: ".products-grid .grid-item .product-image",
                    ratioWrapper: window.images_size
                });
            }
        },
        initInfiniteScrolling: function() {
            if ($('.infinite-scrolling').length > 0) {
                $('.infinite-scrolling a').click(function(e) {
                    e.preventDefault();
                    if (!$(this).hasClass('disabled')) {
                        fashiondable.doInfiniteScrolling();
                    }
                });
            }
        },
        doInfiniteScrolling: function() {
            var currentList = $('.block-row .products-grid');
            if (!currentList.length) {
                currentList = $('.block-row .product-list');
            }
            if (currentList) {
                var showMoreButton = $('.infinite-scrolling a').first();
                $.ajax({
                    type: 'GET',
                    url: showMoreButton.attr("href"),
                    beforeSend: function() {
                        fashiondable.showLoading();
                        $('.loading-modal').show();
                    },
                    success: function(data) {
                        fashiondable.hideLoading();
                        var products = $(data).find(".block-row .products-grid");
                        if (!products.length) {
                            products = $(data).find(".block-row .product-list");
                        }
                        if (products.length) {
                            if (products.hasClass('products-grid')) {
                                /*fake crop*/
                                if (window.product_image_resize) {
                                    products.children().find('img').fakecrop({
                                        fill: window.images_size.is_crop,
                                        widthSelector: ".products-grid .grid-item .product-image",
                                        ratioWrapper: window.images_size
                                    });
                                }
                            }

                            currentList.append(products.children());
                            fashiondable.translateBlock("." + currentList.attr("class"));
                            fashiondable.initQuickView();
                            fashiondable.initAddToCart();
                            fashiondable.initWishlist();
                            //get link of Show more
                            if ($(data).find('.infinite-scrolling').length > 0) {
                                showMoreButton.attr('href', $(data).find('.infinite-scrolling a').attr('href'));
                            } else {
                                //no more products
                                showMoreButton.hide();
                                showMoreButton.next().show();
                            }

                            //currency
                            if (window.show_multiple_currencies && window.shop_currency != jQuery(".currencies").val())
                            {
                                Currency.convertAll(window.shop_currency, jQuery(".currencies").val(), "span.money", "money_format")
                            }

                            fashiondable.initColorSwatchGrid();

                            //product review
                            if ($(".spr-badge").length > 0) {
                                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                            }
                        }
                    },
                    error: function(xhr, text) {
                        fashiondable.hideLoading();
                        $('.loading-modal').hide();
                        $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                        fashiondable.showModal('.ajax-error-modal');
                    },
                    dataType: "html"
                });
            }
        },
        closeEmailModalWindow: function() {
            if ($('#email-modal').length > 0 && $('#email-modal').is(':visible')) {
                $('#email-modal .modal-window').fadeOut(600, function() {
                    $('#email-modal .modal-overlay').fadeOut(600, function() {
                        $('#email-modal').hide();
                        $.cookie('emailSubcribeModal', 'closed', {
                            expires: 1,
                            path: '/'
                        });
                    });
                });
            }
        },
        showModal: function(selector) {
            $(selector).fadeIn(500)
            fashiondable.fashiondableTimeout = setTimeout(function() {
                $(selector).fadeOut(500);
            }, 5000);
        },
        initToggleCollectionPanel: function() {
            if ($('.collection-sharing-btn').length > 0) {
                $('.collection-sharing-btn').click(function() {
                    $('.collection-sharing-panel').toggle();
                    if ($('.collection-sharing-panel').is(':visible')) {
                        $('.collection-sharing-btn').addClass('btn-hover');
                        $('.collection-filter-panel').hide();
                        $('.collection-filter-btn').removeClass('btn-hover');
                    } else {
                        $('.collection-sharing-btn').removeClass('btn-hover');
                    }
                });
            }
            if ($('.collection-filter-btn').length > 0) {
                $('.collection-filter-btn').click(function() {
                    $('.collection-filter-panel').toggle();
                    if ($('.collection-filter-panel').is(':visible')) {
                        $('.collection-filter-btn').addClass('btn-hover');
                        $('.collection-sharing-panel').hide();
                        $('.collection-sharing-btn').removeClass('btn-hover');
                    } else {
                        $('.collection-filter-btn').removeClass('btn-hover');
                    }
                });
                $('.collection-filter-panel select').change(function(index) {
                    window.location = $(this).find('option:selected').val();
                });
            }
        },
        checkItemsInDropdownCart: function() {
            if ($('#dropdown-cart .mini-products-list').children().length > 0) {
                //Has item in dropdown cart
                $('#dropdown-cart .no-items').hide();
                $('#dropdown-cart .has-items').show();
            } else {
                //No item in dropdown cart
                $('#dropdown-cart .has-items').hide();
                $('#dropdown-cart .no-items').show();
            }
        },
        initModal: function() {
            $('.continue-shopping').click(function() {
                clearTimeout(fashiondable.fashiondableTimeout);
                $('.ajax-success-modal').fadeOut(500);
            });
            $('.close-modal, .overlay').click(function() {
                clearTimeout(fashiondable.fashiondableTimeout);
                $('.ajax-success-modal').fadeOut(500);
            });
        },
        initDropDownCart: function() {
            if (window.dropdowncart_type == "click") {
                //click type
                $('#cartToggle').click(function() {
                    if ($('#dropdown-cart').is(':visible')) {
                        $("#dropdown-cart").slideUp('fast');
                    } else {
                        $("#dropdown-cart").slideDown('fast');
                    }
                });
            } else {
                //hover type
                if (!('ontouchstart' in document)) {
                    $('#cartToggle').hover(function() {
                        if (!$('#dropdown-cart').is(':visible')) {
                            $("#dropdown-cart").slideDown('fast');
                        }
                    });
                    $('.wrapper-top-cart').mouseleave(function() {
                        $("#dropdown-cart").slideUp('fast');
                    });
                } else {
                    //mobile
                    $('#cartToggle').click(function() {
                        if ($('#dropdown-cart').is(':visible')) {
                            $("#dropdown-cart").slideUp('fast');
                        } else {
                            $("#dropdown-cart").slideDown('fast');
                        }
                    });
                }
            }

            fashiondable.checkItemsInDropdownCart();

            $('#dropdown-cart .no-items a').click(function() {
                $("#dropdown-cart").slideUp('fast');
            });

            $('#dropdown-cart .btn-remove').click(function(event) {
                event.preventDefault();
                var productId = $(this).parents('.item').attr('id');
                productId = productId.match(/\d+/g);
                Shopify.removeItem(productId, function(cart) {
                    fashiondable.doUpdateDropdownCart(cart);
                });
            });
        },
        closeDropdownCart: function() {
            if ($('#dropdown-cart').is(':visible')) {
                $("#dropdown-cart").slideUp('fast');
            }
        },
        initDropdownSearch: function() {
            $('.nav-search .icon-search').click(function() {
                if ($('.header-center.on .search-bar').is(':visible')) {
                    $('.header-center.on .search-bar').slideUp('fast');
                } else {
                    $('.header-center.on .search-bar').slideDown('fast');
                }
            });
        },
        closeDropdownSearch: function() {
            if ($(".header-center.on .search-bar").is(":visible")) {
                $(".header-center.on .search-bar").slideUp("fast")
            }
        },
        initProductMoreview: function() {
            if ($('.more-view-wrapper-owlslider').length > 0) {
                this.initOwlMoreview();
            };
            if ($('.more-view-wrapper-jcarousel').length > 0) {
                this.initJcarouselMoreview();
            }
        },
        initOwlMoreview: function() {
            $('.more-view-wrapper-owlslider ul').owlCarousel({
                navigation: true,
                items: 4,
                itemsDesktop: [1199, 4],
                itemsDesktopSmall: [979, 3],
                itemsTablet: [768, 3],
                itemsTabletSmall: [540, 3],
                itemsMobile: [360, 3]
            }).css('visibility', 'visible');
        },
        initJcarouselMoreview: function() {
            if (window.innerWidth > 991) {
                $('.more-view-wrapper-jcarousel ul').jcarousel({
                    vertical: true,
                    wrap: 'circular'
                }).css('visibility', 'visible');
            } else {
                var carouselEl = $('.more-view-wrapper-jcarousel ul');
                carouselEl.jcarousel({
                    vertical: false,
                    wrap: 'circular'
                }).css('visibility', 'visible');

                document.querySelector('.more-view-wrapper-jcarousel ul').addEventListener('touchstart', handleTouchStart, false);
                document.querySelector('.more-view-wrapper-jcarousel ul').addEventListener('touchmove', handleTouchMove, false);

                var xDown = null;
                var yDown = null;

                function getTouches(evt) {
                    return evt.touches || evt.originalEvent.touches;
                }

                function handleTouchStart(evt) {
                    const firstTouch = getTouches(evt)[0];
                    xDown = firstTouch.clientX;
                    yDown = firstTouch.clientY;
                };

                function handleTouchMove(evt) {

                    if ( ! xDown || ! yDown ) {
                        return;
                    }

                    var xUp = evt.touches[0].clientX;
                    var yUp = evt.touches[0].clientY;

                    var xDiff = xDown - xUp;
                    var yDiff = yDown - yUp;

                    if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {
                        if ( xDiff > 0 ) {
                            /* left swipe */
                            if (carouselEl) {
                                console.log('left')
                            }
                        } else {
                            /* right swipe */
                            if (carouselEl) {
                                console.log('right')
                            }
                        }
                    }
                    /* reset values */
                    xDown = null;
                    yDown = null;
                };

            }

//             $('.product-img-box').addClass('has-jcarousel');
            $('.more-view-wrapper').css('visibility', 'visible');
        },
        initCloudzoom: function() {
            if ($(".product-featured-image").length > 0) {
                // if ($(".visible-phone").is(":visible")) {
                //     //mobile display
                //     $("#product-featured-image").elevateZoom({
                //         gallery: 'more-view-carousel',
                //         cursor: 'pointer',
                //         galleryActiveClass: 'active',
                //         imageCrossfade: false,
                //         scrollZoom: false,
                //         onImageSwapComplete: function() {
                //             $(".zoomWrapper div").hide();
                //         },
                //         loadingIcon: window.loading_url
                //     });
                //     $("#product-featured-image").bind("click", function(e) {
                //       var ez = $('#product-featured-image').data('elevateZoom');
                //       $.fancybox(ez.getGalleryList());
                //         return false;
                //     });
                // } else {
                    $(".product-featured-image").elevateZoom({
                        gallery: 'js-product-image-main',
                        cursor: 'pointer',
                        galleryActiveClass: 'active',
                        responsive: true,
                        imageCrossfade: true,
                        scrollZoom: false,
                        zoomLens: false,
                        zoomTintFadeIn: 200,
                        zoomTintFadeOut: 200,
                        lensOpacity: 0,
                        containLensZoom: true,
                        zoomType: 'inner',
                        onImageSwapComplete: function() {
                            $(".zoomWrapper div").hide();
                        },
                        loadingIcon: window.loading_url
                    });

                    // $("#product-featured-image").bind("click", function(e) {
                    //     var ez = $('#product-featured-image').data('elevateZoom');
                    //     $.fancybox(ez.getGalleryList());
                    //     return false;
                    // });
                //}
            }
        },
        initScrollTop: function() {
            $('#back-top').click(function() {
                $('body,html').animate({
                    scrollTop: 0
                }, 400);
                return false;
            });
        },
    initDropdown: function() {
      $('.widget-dropdown .widget-title').each(function() {
        $(this).click(function(e) {
          e.preventDefault();
          $(this).toggleClass('click').next().slideToggle('slow');
        });
      });
    },
        //Luong
        initProductAddToCart: function() {
            if ($('#product-add-to-cart').length > 0) {
                $('#product-add-to-cart').click(function(event) {
                    event.preventDefault();
                    if ($(this).attr('disabled') != 'disabled') {
                        var $swatch = $('#add-to-cart-form .swatch')
                        if ($swatch.size() === 0 || $swatch.find('input[type=radio]:checked').size() > 0) {
                            if (!window.ajax_cart) {
                                $(this).closest('form').submit();
                            } else {
                                var variant_id = $('#add-to-cart-form select[name=id]').val();
                                if (!variant_id) {
                                    variant_id = $('#add-to-cart-form input[name=id]').val();
                                }
                                var quantity = $('#add-to-cart-form input[name=quantity]').val();
                                if (!quantity) {
                                    quantity = 1;
                                }
                                var title = $('.product-title h2').html();
                                var image = $('#product-featured-image').attr('src');
                                var message = $('#message').val();
                                fashiondable.doAjaxAddToCart(variant_id, quantity, title, image, message);
                            }
                        } else {
                            fashiondable.hideLoading();
                            $('.loading-modal').hide();
                            $('.ajax-error-message').text('Please select a size first');
                            fashiondable.showModal('.ajax-error-modal');
                        }
                    }
                    return false;
                });
            }
        },
        initAddToCart: function() {
            if ($('.add-to-cart-btn').length > 0) {
                $('.add-to-cart-btn').click(function(event) {
                    event.preventDefault();
                    if ($(this).attr('disabled') != 'disabled') {
                        var productItem = $(this).parents('.product-item');
                        var productId = $(productItem).attr('id');
                        productId = productId.match(/\d+/g);
                        if (!window.ajax_cart) {
                            $('#product-actions-' + productId).submit();
                        } else {
                            var variant_id = $('#product-' + productId + ' .js-product-form-input').val();
                            var quantity = $('#product-actions-' + productId + ' input[name=quantity]').val();
                            if (!quantity) {
                                quantity = 1;
                            }
                            var title = $(productItem).find('.product-title').html();
                            var image = $(productItem).find('.product-grid-image img').attr('src');

                            var message = '';
                            fashiondable.doAjaxAddToCart(variant_id, quantity, title, image, '');
                        }
                    }
                    return false;
                });
            }
      if ($('.upsell-to-cart').length > 0) {
        $(document).on('click', '.upsell-to-cart', function(event) {
          event.preventDefault();
          if ($(this).attr('disabled') != 'disabled') {
            var productItem = $(this).parents('.item');
            var productId = $(productItem).attr('id');
            productId = productId.match(/\d+/g);
            if (!window.ajax_cart) {
              $('#product-actions-' + productId).submit();
            } else {
              var variant_id = $('#product-actions-' + productId + ' select[name=id]').val();
              if (!variant_id) {
                variant_id = $('#product-actions-' + productId + ' input[name=id]').val();
              }
              var quantity = $('#product-actions-' + productId + ' input[name=quantity]').val();
              if (!quantity) {
                quantity = 1;
              }
              var title = $(productItem).find('.product-name a').html();
              var image = $(productItem).find('.product-upsell-image img').attr('src');
              fashiondable.doAjaxAddToCart(variant_id, quantity, title, image, '');
            }
          }
          return false;
        });
      }
      $(document).on('click', '.mini-products .has-variant', function(e) {
        e.preventDefault();
        var variant_id = $(this).parent().find('.item_option a.active').data('id');
		var quantity = 1;
        var title = $(this).closest('.item').find('p.product-name a').html();
        var image = $(this).closest('.item').find('.product-upsell-image img').attr('src');
        fashiondable.doAjaxAddToCart(variant_id, quantity, title, image, '');
      });
        },
        showLoading: function() {
            $('.loading-modal').show();
        },
        hideLoading: function() {
            $('.loading-modal').hide();
        },
        doAjaxAddToCart: function(variant_id, quantity, title, image, message) {
            $.ajax({
                type: "post",
                url: "/cart/add.js",
                data: {
                    quantity: quantity,
                    id: variant_id,
                    properties: {
                        Message: message
                    }
                },
                dataType: 'json',
                beforeSend: function() {
                    fashiondable.showLoading();
                },
                success: function(msg) {

                    $('.ajax-success-modal').find('.ajax-product-title').html(fashiondable.translateText(title));
                    $('.ajax-success-modal').find('.ajax-product-image').attr('src', image);
                    $('.ajax-success-modal').find('.btn-go-to-wishlist').hide();
                    $('.ajax-success-modal').find('.btn-go-to-cart').show();

          //fashiondable.showModal('.ajax-success-modal');
                    fashiondable.updateDropdownCart();
          fashiondable.refreshMiniCart();
          $("html, body").animate({ scrollTop: 0 }, "slow");
                },
                error: function(xhr, text) {
                    fashiondable.hideLoading();
                    $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                    fashiondable.showModal('.ajax-error-modal');
                }
            });
    },
    refreshMiniCart:  function(){
      if ($('body').hasClass('template-cart')) {
        window.location.reload();
      } else {
        $.ajax({
          method: "GET",
          url: "/cart",
          data: {"view": "ajax"},
          xhrFields: {
            withCredentials: true
          },
          dataType: 'html',
          success: function(response) {
            var CartCount = $(response).find('#cartCount').html();
            var contentCartHtml = $(response).find('#toggle-cart-slide').html();
            if(CartCount){
              $('#cartCount').text(CartCount);
            }
            if (contentCartHtml) {
              $('#toggle-cart-slide').html(contentCartHtml);
              if($('.mini-products .product-list-item li').length > 0){
                fashiondable.initUpsellProductOwl();
              }
            }
            fashiondable.hideLoading();
            $('.top-cart > a').trigger('click');
          }
        });
      }
    },
    initUpsellProductOwl: function(){
      $('.hide-product-list-item').on('click', function(e) {
        $(this).parent().removeClass('active');
        var id = $(this).parent().attr('data-id');
        $.cookie(id, 'removed', { expires : 1 });
        checkShopTheLook();
      });
      $('.mini-products .product-list-item').each( function(){
        $(this).owlCarousel({
          items: 1,
          itemsDesktop: [1199, 1],
          itemsDesktopSmall: [979, 1],
          itemsTablet: [768, 1],
          itemsTabletSmall: [540, 1],
          itemsMobile: [360, 1],
          autoPlay: 5000
        });
      });
      checkShopTheLook();
        },
        prepareQuickView: function(button) {
          var product_handle = button.attr('id');
          Shopify.getProduct(product_handle, function(product) {
            var template = $('#quickview-template').html();
            $('.quick-view').html(template);
            var quickview = $('.quick-view');

            quickview.find('.product-title a').html(fashiondable.translateText(product.title));
            quickview.find('.product-title a').attr('href', product.url);
            if (quickview.find('.vendor span').length > 0) {
              quickview.find('.vendor span').text(product.vendor);
            }
            if (quickview.find('.product-type span').length > 0) {
              quickview.find('.product-type span').text(product.type);
            }
            if (quickview.find('.product-inventory span').length > 0) {
              var variant = product.variants[0];
              var inventoryInfo = quickview.find('.product-inventory span');
              if (variant.available) {
                if (variant.inventory_management!=null) {
                  inventoryInfo.text(window.inventory_text.in_stock);
                } else {
                  inventoryInfo.text(window.inventory_text.many_in_stock);
                }
              } else {
                inventoryInfo.text(window.inventory_text.out_of_stock);
              }
            }
            //countdown for quickview
            if (product.description.indexOf("[countdown]") > 0) {
              var countdownTime = product.description.match(/\[countdown\](.*)\[\/countdown\]/);
              if (countdownTime && countdownTime.length > 0) {
                quickview.find(".countdown").show();
                quickview.find(".quickview-clock").countdown(countdownTime[1], function(event) {
                  button.html(event.strftime('%Dd %H:%M:%S'));
                });
              }
            }
            if (quickview.find('.product-description').length > 0) {
              var description = product.description.replace(/(<([^>]+)>)/ig, "");
              var description = description.replace(/\[countdown\](.*)\[\/countdown\]/g, "");
              if (window.multi_lang) {
                if (description.indexOf("[lang2]") > 0) {
                  var descList = description.split("[lang2]");
                  if (jQuery.cookie("language") != null) {
                    description = descList[translator.current_lang - 1];
                  } else {
                    description = descList[0];
                  }
                }
              }
              description = description.split(" ").splice(0, 20).join(" ") + "...";
              quickview.find('.product-description').text(description);
            } else {
              quickview.find('.product-description').remove();
            }

            quickview.find('.price').html(Shopify.formatMoney(product.price, window.money_format));
            quickview.find('.product-item').attr('id', 'product-' + product.id);
            quickview.find('.variants').attr('id', 'product-actions-' + product.id);
            quickview.find('.variants select').attr('id', 'product-select-' + product.id);
            quickview.find('.product-img-box').attr('id', 'product-' + product.id);

            // review
            var in_fo = $('#product-'+ product.id +' .spr-badge').html();
            $('#product-'+ product.id +' .re_view').html(in_fo);

            // Sold Out


            var in_fo = $('#product-'+ product.id +' .product-label').html();
            $('#product-'+ product.id +' .product-label-qiuck').html(in_fo);



            //if has compare price
            if (product.compare_at_price > product.price) {
              quickview.find('.compare-price').html(Shopify.formatMoney(product.compare_at_price_max, window.money_format)).show();
              quickview.find('.price').addClass('on-sale');
            } else {
              quickview.find('.compare-price').html('');
              quickview.find('.price').removeClass('on-sale');
            }

            //out of stock
            if (!product.available) {
              quickview.find("select, input, .total-price, .dec, .inc, .variants label").remove();
              quickview.find(".add-to-cart-btn").text(window.inventory_text.unavailable).addClass('disabled').attr("disabled", "disabled");;
            } else {
              quickview.find('.total-price span').html(Shopify.formatMoney(product.price, window.money_format));
              if (window.use_color_swatch) {
                fashiondable.createQuickViewVariantsSwatch(product, quickview);
              } else {
                fashiondable.createQuickViewVariants(product, quickview);
              }
            }

            //quantity
            quickview.find(".button").on("click", function() {
              var oldValue = quickview.find(".quantity").val(),
                newVal = 1;
              if (button.text() == "+") {
                newVal = parseInt(oldValue) + 1;
              } else if (oldValue > 1) {
                newVal = parseInt(oldValue) - 1;
              }
              quickview.find(".quantity").val(newVal);

              if (quickview.find(".total-price").length > 0) {
                fashiondable.updatePricingQuickview();
              }
            });

            if (window.show_multiple_currencies) {
              var cookie_value = $.cookie("currency");
              var abc =  jQuery('.currency .currencies.selectized').val();
              setTimeout(function(){ Currency.convertAll(cookie_value, abc, 'span.money', 'money_format'); }, 1000);
              //Currency.convertAll(window.shop_currency, jQuery('.currency .currencies.selectized').val(), 'span.money', 'money_format');
            }

            fashiondable.loadQuickViewSlider(product, quickview);
            fashiondable.initQuickviewAddToCart(product);
            fashiondable.translateBlock(".quick-view");

            $('.quick-view').fadeIn(500);
            if ($('.quick-view .total-price').length > 0) {
              $('.quick-view input[name=quantity]').on('change', fashiondable.updatePricingQuickview);
            }
          });

          return false;
        },
        initQuickView: function() {
            $('.quickview-button a').click(function() {
              fashiondable.prepareQuickView($(this));
            });

            $(document).on("click", ".quick-view .overlay, .close-window", function() {
                fashiondable.closeQuickViewPopup();
                return false;
            });
        },
        updatePricingQuickview: function() {
            //try pattern one before pattern 2
            var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
            var unitPriceTextMatch = $('.quick-view .price').text().match(regex);

            if (!unitPriceTextMatch) {
                regex = /([0-9]+[.|,][0-9]+)/g;
                unitPriceTextMatch = $('.quick-view .price').text().match(regex);
            }

            if (unitPriceTextMatch) {
                var unitPriceText = unitPriceTextMatch[0];
                var unitPrice = unitPriceText.replace(/[.|,]/g, '');
                var quantity = parseInt($('.quick-view input[name=quantity]').val());
                var totalPrice = unitPrice * quantity;

                var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);
                regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
                if (!totalPriceText.match(regex)) {
                   regex = /([0-9]+[.|,][0-9]+)/g;
                }
                totalPriceText = totalPriceText.match(regex)[0];

                var regInput = new RegExp(unitPriceText, "g");
                var totalPriceHtml = $('.quick-view .price').html().replace(regInput, totalPriceText);

                $('.quick-view .total-price span').html(totalPriceHtml);
            }
        },
        initQuickviewAddToCart: function (product) {
            if ($('.quick-view .add-to-cart-btn').length > 0) {
                $('.quick-view .add-to-cart-btn').click(function() {
                    var variant_id = $('.quick-view select[name=id]').val();
                    if (product.variants.length > 0) {
                        for (var i = 0; i < product.variants.length; i++) {
                            var variant = product.variants[i];
                            if (variant_id === variant.title) {
                                variant_id = variant.id
                            }
                        }
                    }
                    if (!variant_id) {
                        variant_id = $('.quick-view input[name=id]').val();
                    }
                    var quantity = $('.quick-view input[name=quantity]').val();
                    if (!quantity) {
                        quantity = 1;
                    }
                    var title = $('.quick-view .product-title a').html();
                    var image = $('.quick-view .quickview-featured-image img').attr('src');
                    fashiondable.doAjaxAddToCart(variant_id, quantity, title, image, '');
                    fashiondable.closeQuickViewPopup();
                });
            }
        },
        updateDropdownCart: function() {
            Shopify.getCart(function(cart) {
                fashiondable.doUpdateDropdownCart(cart);
            });
        },
        doUpdateDropdownCart: function(cart) {
            var template = '<li class="item" id="cart-item-{ID}"><a href="{URL}" title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-details"><a href="javascript:void(0)" title="Remove This Item" class="btn-remove"></a><p class="product-name"><a href="{URL}">{TITLE}</a></p><div class="cart-collateral">{QUANTITY} x <span class="price">{PRICE}</span></div></div></li>';

            $('#cartCount').text(cart.item_count);
          $('#fixcartCount').text(cart.item_count);
            /*Total price*/
            $('#dropdown-cart .summary .price').html(Shopify.formatMoney(cart.total_price, window.money_format));
            /*Clear cart*/
            $('#dropdown-cart .mini-products-list').html('');
            /*Add product to cart*/
            if (cart.item_count > 0) {
                for (var i = 0; i < cart.items.length; i++) {
                    var item = template;
                    item = item.replace(/\{ID\}/g, cart.items[i].id);
                    item = item.replace(/\{URL\}/g, cart.items[i].url);
                    item = item.replace(/\{TITLE\}/g, fashiondable.translateText(cart.items[i].title));
                    item = item.replace(/\{QUANTITY\}/g, cart.items[i].quantity);
                    item = item.replace(/\{IMAGE\}/g, Shopify.resizeImage(cart.items[i].image, 'small'));
                    item = item.replace(/\{PRICE\}/g, Shopify.formatMoney(cart.items[i].price, window.money_format));
                    $('#dropdown-cart .mini-products-list').append(item);
                }
                $('#dropdown-cart .btn-remove').click(function(event) {
                    event.preventDefault();
                    var productId = $(this).parents('.item').attr('id');
                    productId = productId.match(/\d+/g);
                    Shopify.removeItem(productId, function(cart) {
                        fashiondable.doUpdateDropdownCart(cart);
                    });
                });
                if (fashiondable.checkNeedToConvertCurrency()) {
                    Currency.convertAll(window.shop_currency, jQuery('.currencies').val(), '#dropdown-cart span.money', 'money_format');
                }
            }
            fashiondable.checkItemsInDropdownCart();
        },
        checkNeedToConvertCurrency: function() {
            return window.show_multiple_currencies && Currency.currentCurrency != shopCurrency;
        },
        loadQuickViewSlider: function(product, quickviewTemplate) {
            var featuredImage = Shopify.resizeImage(product.featured_image, 'grande');
            quickviewTemplate.find('.quickview-featured-image').append('<a href="' + product.url + '"><img src="' + featuredImage + '" title="' + product.title + '"/><div style="height: 100%; width: 100%; top:0; left:0 z-index: 2000; position: absolute; display: none; background: url(' + window.loading_url + ') 50% 50% no-repeat;"></div></a>');
            if (product.images.length > 1) {
                var quickViewCarousel = quickviewTemplate.find('.more-view-wrapper ul');
                var count = 0;
                for (i in product.images) {
                    if (count < product.images.length) {
                        var grande = Shopify.resizeImage(product.images[i], 'grande');
                        var compact = Shopify.resizeImage(product.images[i], 'compact');
                        var item = '<li><a href="javascript:void(0)" data-image="' + grande + '"><img src="' + compact + '"  /></a></li>'

                        quickViewCarousel.append(item);
                        count = count + 1;
                    }
                }

                quickViewCarousel.find('a').click(function() {
                    var quickViewFeatureImage = quickviewTemplate.find('.quickview-featured-image img');
                    var quickViewFeatureLoading = quickviewTemplate.find('.quickview-featured-image div');
                    if (quickViewFeatureImage.attr('src') != $(this).attr('data-image')) {
                        quickViewFeatureImage.attr('src', $(this).attr('data-image'));
                        quickViewFeatureLoading.show();
                        quickViewFeatureImage.load(function(e) {
                            quickViewFeatureLoading.hide();
                            $(this).unbind('load');
                            quickViewFeatureLoading.hide();
                        });
                    }
                });
                if (quickViewCarousel.hasClass("quickview-more-views-owlslider")) {
                    fashiondable.initQuickViewCarousel(quickViewCarousel);
                } else {
                    fashiondable.initQuickViewVerticalMoreview(quickViewCarousel);
                }
            } else {
                quickviewTemplate.find('.quickview-more-views').remove();
                quickviewTemplate.find('.quickview-more-view-wrapper-jcarousel').remove();
            }

        },
        initQuickViewCarousel: function(quickViewCarousel) {
            if (quickViewCarousel) {
                quickViewCarousel.owlCarousel({
                    navigation: true,
                    items: 4,
                    itemsDesktop: [1199, 4],
                    itemsDesktopSmall: [979, 3],
                    itemsTablet: [768, 3],
                    itemsTabletSmall: [540, 3],
                    itemsMobile: [360, 3]
                }).css('visibility', 'visible');
            }
        },
        initQuickViewVerticalMoreview: function(quickViewCarousel) {
            if (quickViewCarousel) {
                quickViewCarousel.jcarousel({
                    vertical: true
                });
                $('.product-img-box').addClass('has-jcarousel');
                $('.more-view-wrapper').css('visibility', 'visible');
            }
        },
        convertToSlug: function(text) {
            return text
                .toLowerCase()
                .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
                .replace(/\s+/g, '-')
                .replace(/-+/g, '-');
        },
        createQuickViewVariantsSwatch: function(product, quickviewTemplate) {
            if (product.variants.length > 1) { //multiple variants
                // for (var i = 0; i < product.variants.length; i++) {
                //     var variant = product.variants[i];
                //     var option = '<option value="' + variant.id + '">' + variant.title + '</option>';
                //     quickviewTemplate.find('form.variants > select').append(option);
                // }
                var options = "";
                 for (var i = 0; i < product.options.length; i++) {
                     if (/size/i.test(product.options[i].name)) {
                             options += '<div class="swatch clearfix" data-option-index="' + i + '">';
                             options += '<div class="header"><em>*</em>' + product.options[i].name + '</div>';
                     }
                 }
                quickviewTemplate.find('form.variants > select').before(options);

                new Shopify.OptionSelectors("product-select-" + product.id, {
                    product: product,
                    onVariantSelected: selectCallbackQuickview
                });
                quickviewTemplate.find('form.variants .single-option-selector').attr('name', 'id');

                //start of quickview variant;
                // var filePath = window.file_url.substring(0, window.file_url.lastIndexOf('?'));
                // var assetUrl = window.asset_url.substring(0, window.asset_url.lastIndexOf('?'));
                // var options = "";
                // for (var i = 0; i < product.options.length; i++) {
                //   if (/Color|Colour|size/i.test(product.options[i].name)) {
                //     options += '<div class="swatch clearfix" data-option-index="' + i + '">';
                //     options += '<div class="header"><em>*</em>' + product.options[i].name + '</div>';
                //     var is_color = false;
                //     if (/Color|Colour/i.test(product.options[i].name)) {
                //         is_color = true;
                //     }
                //     var optionValues = new Array();
                //     for (var j = 0; j < product.variants.length; j++) {
                //         var variant = product.variants[j];
                //         var value = variant.options[i];
                //         var valueHandle = this.convertToSlug(value);
                //         var forText = 'swatch-' + i + '-' + valueHandle;
                //         if (optionValues.indexOf(value) < 0) {
                //             //not yet inserted
                //             options += '<div data-value="' + value + '" class="swatch-element ' + (is_color ? "color" : "") + valueHandle + (variant.available ? ' available ' : ' soldout ') + '">';
                //
                //             if (is_color) {
                //                 options += '<div class="tooltip">' + value + '</div>';
                //             }
                //             options += '<input id="' + forText + '" type="radio" name="option-' + i + '" value="' + value + '" ' + (j == 0 ? ' checked ' : '') + (variant.available ? '' : ' disabled') + ' />';
                //
                //             if (is_color) {
                //                     options += '<label for="' + forText + '" style="background-color: ' + valueHandle + '; background-image: url(' + filePath + valueHandle + '.png)"><img class="crossed-out" src="' + assetUrl + 'soldout.png" /></label>';
                //                 } else {
                //                     options += '<label for="' + forText + '">' + value + '<img class="crossed-out" src="' + assetUrl + 'soldout.png" /></label>';
                //             }
                //             options += '</div>';
                //             if (variant.available) {
                //                 $('.quick-view .swatch[data-option-index="' + i + '"] .' + valueHandle).removeClass('soldout').addClass('available').find(':radio').removeAttr('disabled');
                //             }
                //             optionValues.push(value);
                //         }
                //     }
                //     options += '</div>';
                //   } else {
                //     quickviewTemplate.find('.selector-wrapper').show();
                //     quickviewTemplate.find('form.variants .selector-wrapper label').each(function(i, v) {
                //       $(this).html('<em>*</em>' + product.options[i].name);
                //       quickviewTemplate.find('.selector-wrapper label:contains(Color)').parent().hide();
                //       quickviewTemplate.find('.selector-wrapper label:contains(Size)').parent().hide();
                //     });
                //     if (product.options.length == 1) {
                //       quickviewTemplate.find('.selector-wrapper:eq(0)').prepend('<label>' + product.options[0].name + '<em>*</em></label>');
                //       for (var text = product.variants, r = 0; r < text.length; r++ ) {
                //         var s = text[r];
                //         if (!s.available) {
                //           jQuery('.single-option-selector option').filter(function() { return jQuery(this).html() === s.title }).remove();
                //         }
                //       };
                //     }
                //   }
                // }
                // quickviewTemplate.find('form.variants .selector-wrapper:eq(0)').before(options);
                // quickviewTemplate.find('.swatch :radio').change(function() {
                //     var optionIndex = $(this).closest('.swatch').attr('data-option-index');
                //     var optionValue = $(this).val();
                //     $(this)
                //         .closest('form')
                //         .find('.single-option-selector')
                //         .eq(optionIndex)
                //         .val(optionValue)
                //         .trigger('change');
                //         // var cookie_value = $.cookie("currency");
                //         // var abc =  jQuery('.currency .currencies.selectized').val();
                //         // Currency.convertAll(cookie_value, abc, 'span.money', 'money_format');
                // });
                // if (product.available) {
                //     Shopify.optionsMap = {};
                //     Shopify.linkOptionSelectors(product);
                // }

                //end of quickview variant
            } else { //single variant
                quickviewTemplate.find('form.variants > select').remove();
                var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
                quickviewTemplate.find('form.variants').append(variant_field);
            }
        },
        createQuickViewVariants: function(product, quickviewTemplate) {
            if (product.variants.length > 1) { //multiple variants
                for (var i = 0; i < product.variants.length; i++) {
                    var variant = product.variants[i];
                    var option = '<option value="' + variant.id + '">' + variant.title + '</option>';
                    quickviewTemplate.find('form.variants > select').append(option);
                }

                new Shopify.OptionSelectors("product-select-" + product.id, {
                    product: product,
                    onVariantSelected: selectCallbackQuickview
                });

                if (product.options.length == 1) {
                    $('.selector-wrapper:eq(0)').prepend('<label>' + product.options[0].name + '</label>');
                    for (var text = product.variants, r = 0; r < text.length; r++ ) {
                      var s = text[r];
                      if (!s.available) {
                        jQuery('.single-option-selector option').filter(function() { return jQuery(this).html() === s.title }).remove();
                      }
                    };
                }

                $('.quick-view .single-option-selector').selectize();
                $('.quick-view .selectize-input input').attr("disabled", "disabled");

                quickviewTemplate.find('form.variants .selector-wrapper label').each(function(i, v) {
                    $(this).html(product.options[i].name);
                });
            } else { //single variant
                quickviewTemplate.find('form.variants > select').remove();
                var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
                quickviewTemplate.find('form.variants').append(variant_field);
            }

        },
        closeQuickViewPopup: function() {
            $('.quick-view').fadeOut(500);
        },
        translateText: function(str) {
          if (!window.multi_lang || str.indexOf("|") < 0)
            return str;

          if (window.multi_lang) {
            var textArr = str.split("|");
            if (translator.isLang2())
              return textArr[1];
            return textArr[0];
          }
        },
      translateBlock: function(blockSelector) {
          if (window.multi_lang && translator.isLang2()) {
          translator.doTranslate(blockSelector);
        }
      }
    }
})(jQuery);
